import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { screeningAction } from '../../actions/constant';
import screeningService from '../../../services/apiServices/screeningDetails/screeningDetails';
const {
  POST_SCREENING_SUBMISSION_SUCCESS,
  POST_SCREENING_SUBMISSION_FAILURE,
  POST_SCREENING_SUBMISSION_LOADER,
  POST_SCREENING_SUBMISSION_REQUEST,
} = screeningAction;

function* saveScreeningSubmission(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: POST_SCREENING_SUBMISSION_LOADER });
    const response = yield call(screeningService.postScreeningSubmission, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: POST_SCREENING_SUBMISSION_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: POST_SCREENING_SUBMISSION_FAILURE, payload: error });
  }
}

function* saveScreeningSubmissionSaga() {
  yield takeEvery(POST_SCREENING_SUBMISSION_REQUEST, saveScreeningSubmission);
}

export default saveScreeningSubmissionSaga;
